(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uradora-bestsellers"] && !Shopify.designMode) return;
  try {
    
  class UradoraFilter extends HTMLElement {
    connectedCallback() {
      this.filters = [...this.querySelectorAll('[data-uradora-filter]')];
      this.items = [...this.querySelectorAll('.uradora-products__item')];
      this.more = this.querySelector('[data-uradora-more]');
      this.empty = this.querySelector('[data-uradora-empty]');

      this.filter = 'all';
      this.chip = '';
      this.limit = Number(this.dataset.limit) || 8;

      this.filters.forEach((button) => {
        button.addEventListener('click', () => this.apply(button));
      });

      this.render();
    }

    apply(button) {
      this.filter = button.dataset.uradoraFilter;
      this.chip = button.dataset.uradoraChip || '';

      this.filters.forEach((candidate) => {
        const active = candidate === button;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-pressed', String(active));
      });

      if (this.more && button.dataset.uradoraUrl) this.more.href = button.dataset.uradoraUrl;

      this.render();
    }

    matching() {
      if (this.filter === 'all') return this.items;

      const tokens = this.filter.split(' ').filter(Boolean);

      return this.items.filter((item) => {
        const collections = (item.dataset.collections || '').split(' ').filter(Boolean);
        return tokens.some((token) => collections.includes(token));
      });
    }

    render() {
      const visible = new Set(this.matching().slice(0, this.limit));

      this.items.forEach((item) => {
        item.hidden = !visible.has(item);

        // The chip names the selected filter, or under All the product's first filter.
        const chip = item.querySelector('[data-ucard-chip]');
        if (chip) chip.textContent = this.filter === 'all' ? item.dataset.chipAll : this.chip;
      });

      if (this.empty) this.empty.hidden = visible.size > 0;
    }
  }

  if (!customElements.get('uradora-filter')) {
    customElements.define('uradora-filter', UradoraFilter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uradora-footer"] && !Shopify.designMode) return;
  try {
    
  class UradoraFooter extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => {
        const toggle = event.target.closest('[data-ufooter-toggle]');
        if (!toggle || !this.contains(toggle)) return;

        const column = toggle.closest('[data-ufooter-column]');
        const open = toggle.getAttribute('aria-expanded') !== 'true';

        toggle.setAttribute('aria-expanded', String(open));
        if (column) column.toggleAttribute('data-open', open);
      };

      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }
  }

  if (!customElements.get('uradora-footer')) {
    customElements.define('uradora-footer', UradoraFooter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uradora-header"] && !Shopify.designMode) return;
  try {
    
  const DESKTOP = '(min-width: 990px)';
  const HOVER_IN = 90;
  const HOVER_OUT = 180;

  class UradoraHeader extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.uheader__bar');
      this.nav = this.querySelector('.uheader__nav');
      this.toggle = this.querySelector('[data-uheader-toggle]');
      this.scrim = this.querySelector('[data-uheader-scrim]');
      this.items = [...this.querySelectorAll('[data-unav-item]')];
      this.groups = [...this.querySelectorAll('[data-unav-group]')];
      this.media = window.matchMedia(DESKTOP);

      this.openTimer = null;
      this.closeTimer = null;
      this.navOpen = false;
      this.lastScroll = this.scrollTop();

      this.bindItems();
      this.bindGroups();
      this.bindChrome();

      this.media.addEventListener('change', () => this.syncMode());
      this.syncMode();

      this.onScroll = this.onScroll.bind(this);
      this.scroller().addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('scroll', this.onScroll, { passive: true });

      this.resize = new ResizeObserver(() => this.measure());
      this.resize.observe(this.bar);
      this.measure();
    }

    disconnectedCallback() {
      this.scroller().removeEventListener('scroll', this.onScroll);
      window.removeEventListener('scroll', this.onScroll);
      this.resize?.disconnect();
      document.documentElement.style.removeProperty('overflow');
    }

    scroller() {
      return document.querySelector('.page-wrapper') || window;
    }

    scrollTop() {
      const wrapper = document.querySelector('.page-wrapper');
      return Math.max(wrapper ? wrapper.scrollTop : 0, window.scrollY || 0);
    }

    measure() {
      const height = this.bar?.getBoundingClientRect().height;
      if (height) this.style.setProperty('--unav-measured-h', `${Math.round(height)}px`);
    }

    isDesktop() {
      return this.media.matches;
    }

    /* ---------- top level ---------- */
    bindItems() {
      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-unav-category-trigger]');
        if (!trigger) return;

        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          if (this.isDesktop()) {
            this.setItem(item, !item.classList.contains('is-open'));
          } else {
            this.setItem(item, true);
          }
        });

        item.addEventListener('mouseenter', () => {
          if (!this.isDesktop()) return;
          clearTimeout(this.closeTimer);
          this.openTimer = setTimeout(() => this.setItem(item, true), HOVER_IN);
        });

        item.addEventListener('mouseleave', () => {
          if (!this.isDesktop()) return;
          clearTimeout(this.openTimer);
          this.closeTimer = setTimeout(() => this.setItem(item, false), HOVER_OUT);
        });
      });

      this.addEventListener('focusout', (event) => {
        if (!this.isDesktop()) return;
        if (this.contains(event.relatedTarget)) return;
        this.closeAll();
      });

      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (this.navOpen) {
          this.setNav(false);
          this.toggle?.focus();
        } else {
          this.closeAll();
        }
      });
    }

    setItem(item, open) {
      if (open) this.items.forEach((other) => other !== item && this.setItem(other, false));

      item.classList.toggle('is-open', open);
      item.querySelector('[data-unav-category-trigger]')?.setAttribute('aria-expanded', String(open));

      if (!open) {
        item.querySelectorAll('[data-unav-group].is-active').forEach((group) => {
          group.classList.remove('is-active');
          group.querySelector('[data-unav-group-trigger]')?.setAttribute('aria-expanded', 'false');
        });
      }
    }

    closeAll() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      this.items.forEach((item) => this.setItem(item, false));
    }

    /* ---------- groups (mobile third level) ---------- */
    bindGroups() {
      this.groups.forEach((group) => {
        const trigger = group.querySelector('[data-unav-group-trigger]');
        trigger?.addEventListener('click', () => {
          if (this.isDesktop()) return;
          group.classList.add('is-active');
          trigger.setAttribute('aria-expanded', 'true');
        });
      });

      this.querySelectorAll('[data-unav-back]').forEach((back) => {
        back.addEventListener('click', () => {
          const group = back.closest('[data-unav-group]');
          if (group && group.classList.contains('is-active')) {
            group.classList.remove('is-active');
            group.querySelector('[data-unav-group-trigger]')?.setAttribute('aria-expanded', 'false');
            return;
          }

          const item = back.closest('[data-unav-item]');
          if (item) this.setItem(item, false);
        });
      });
    }

    /* ---------- drawer ---------- */
    bindChrome() {
      this.toggle?.addEventListener('click', () => this.setNav(!this.navOpen));
      this.scrim?.addEventListener('click', () => this.setNav(false));
    }

    setNav(open) {
      this.navOpen = open;
      this.classList.toggle('is-nav-open', open);
      this.toggle?.setAttribute('aria-expanded', String(open));

      if (this.scrim) {
        if (open) {
          this.scrim.hidden = false;
        } else {
          setTimeout(() => {
            if (!this.navOpen) this.scrim.hidden = true;
          }, 300);
        }
      }

      document.documentElement.style.overflow = open ? 'hidden' : '';

      if (!open) this.closeAll();
      if (open) this.classList.remove('is-hidden');
    }

    /* ---------- mode ---------- */
    syncMode() {
      const desktop = this.isDesktop();

      // Group headings are plain headings on desktop; keep them out of the tab order there.
      this.groups.forEach((group) => {
        const trigger = group.querySelector('[data-unav-group-trigger]');
        if (!trigger) return;
        if (desktop) {
          trigger.setAttribute('tabindex', '-1');
          trigger.setAttribute('aria-expanded', 'true');
        } else {
          trigger.removeAttribute('tabindex');
          trigger.setAttribute('aria-expanded', String(group.classList.contains('is-active')));
        }
      });

      if (desktop && this.navOpen) this.setNav(false);
      if (!desktop) this.closeAll();
    }

    /* ---------- scroll ---------- */
    onScroll() {
      if (this.dataset.hideOnScroll === 'false') return;
      if (this.navOpen) return;

      const top = this.scrollTop();
      const barHeight = this.bar?.offsetHeight ?? 0;

      if (top <= barHeight) {
        this.classList.remove('is-hidden');
      } else if (top > this.lastScroll + 4) {
        this.classList.add('is-hidden');
        this.closeAll();
      } else if (top < this.lastScroll - 4) {
        this.classList.remove('is-hidden');
      }

      this.lastScroll = top;
    }
  }

  if (!customElements.get('uradora-header')) {
    customElements.define('uradora-header', UradoraHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uradora-hero"] && !Shopify.designMode) return;
  try {
    
  class UradoraHero extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('.uradora-hero__video');
      this.motionButton = this.querySelector('[data-uradora-motion]');
      this.scrollButton = this.querySelector('[data-uradora-scroll]');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.scrollButton) {
        this.scrollButton.addEventListener('click', () => this.scrollToContent());
      }

      if (!this.video) return;

      if (this.video.readyState >= 3) {
        this.classList.add('is-video-ready');
      } else {
        this.video.addEventListener('loadeddata', () => this.classList.add('is-video-ready'), { once: true });
      }

      if (this.reduceMotion) {
        this.video.pause();
        this.video.removeAttribute('autoplay');
        this.setMotionState(true);
      }

      if (this.motionButton) {
        this.motionButton.addEventListener('click', () => this.toggleMotion());
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (this.paused) return;
          if (entry.isIntersecting) {
            const playback = this.video.play();
            if (playback) playback.catch(() => {});
          } else {
            this.video.pause();
          }
        });
      });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    toggleMotion() {
      this.setMotionState(!this.paused);
    }

    setMotionState(paused) {
      this.paused = paused;

      if (paused) {
        this.video.pause();
      } else {
        const playback = this.video.play();
        if (playback) playback.catch(() => {});
      }

      if (!this.motionButton) return;

      this.motionButton.setAttribute('aria-pressed', String(paused));
      const label = this.motionButton.querySelector('[data-uradora-motion-label]');
      if (label) label.textContent = paused ? 'Play background video' : 'Pause background video';
    }

    scrollToContent() {
      const next = this.parentElement?.nextElementSibling ?? this.nextElementSibling;
      const behavior = this.reduceMotion ? 'auto' : 'smooth';

      if (next) {
        next.scrollIntoView({ behavior, block: 'start' });
        return;
      }

      const scroller = this.scrollParent();
      scroller.scrollBy({ top: this.offsetHeight, behavior });
    }

    scrollParent() {
      let node = this.parentElement;

      while (node) {
        const overflow = getComputedStyle(node).overflowY;
        if (overflow === 'auto' || overflow === 'scroll') return node;
        node = node.parentElement;
      }

      return document.scrollingElement ?? document.documentElement;
    }
  }

  if (!customElements.get('uradora-hero')) {
    customElements.define('uradora-hero', UradoraHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uradora-occasions"] && !Shopify.designMode) return;
  try {
    
  class UradoraOccasions extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-uradora-track]');
      this.controls = this.querySelector('[data-uradora-controls]');
      this.prev = this.querySelector('[data-uradora-prev]');
      this.next = this.querySelector('[data-uradora-next]');

      if (!this.track || !this.controls) return;

      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.prev.addEventListener('click', () => this.go(-1));
      this.next.addEventListener('click', () => this.go(1));

      this.resizeObserver = new ResizeObserver(this.onScroll);
      this.resizeObserver.observe(this.track);
      this.track.querySelectorAll('.uradora-occasions__item').forEach((item) => this.resizeObserver.observe(item));

      this.update();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    step() {
      const item = this.track.querySelector('.uradora-occasions__item');
      if (!item) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    go(direction) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * this.step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const position = this.track.scrollLeft;

      this.controls.hidden = max <= 1;
      this.prev.disabled = position <= 1;
      this.next.disabled = position >= max - 1;
    }
  }

  if (!customElements.get('uradora-occasions')) {
    customElements.define('uradora-occasions', UradoraOccasions);
  }

  } catch(e) { console.error(e); }
})();
})();
